class ContactConfirm {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const formInput = '.mw_wp_form_input';
    const formConfirm = '.mw_wp_form_confirm';
    const formComplete = '.mw_wp_form_complete';
    const formInputText = '.js-contact-input';
    const formConfirmText = '.js-contact-confirm';
    const formCompleteText = '.js-contact-complete';
    const completeHide = '.js-contact-complete-hide';
    const formError = '.mw_wp_form_send_error';
    const errorHideWrap = '.js-contact-error-hide';
    if($(formInput).length){
      $(formConfirmText).hide();
      $(formCompleteText).hide();
    }
    if($(formConfirm).length){
      $(formInputText).hide();
      $(formCompleteText).hide();
    }
    if($(formComplete).length){
      $(formInputText).hide();
      $(formConfirmText).hide();
      $(completeHide).hide();
    }
    if($(formError).length){
      $(errorHideWrap).hide();
    }
  }
}
